import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
}));

const OfficiantInvoicesList = () => {
    const classes = useStyles();

    useEffect(() => {
        document.title = 'Officiant Invoices - Enduring Promises';
    });

    return (
        <Paper square className={classes.paper}>
            <div style={{ maxWidth: '100%' }}>
                <Typography variant="h6">Officiant Invoices</Typography>
                <div>Coming later</div>
            </div>
        </Paper>
    )
}

export default OfficiantInvoicesList;
